<template>
  <div>
    <md-card class="card-container">
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <page-title :title="isEditing ? '修改角色' : '新增角色'"></page-title>
        </div>
      </div>
      <div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <md-field>
              <label>名稱</label>
              <md-input v-model="data.name"></md-input>
            </md-field>
          </div>
        </div>
      </div>
      <md-divider></md-divider>
      <div class="md-layout md-gutter" v-for="scope in scopes">
        <div class="md-layout-item">
          <md-checkbox v-model="scope.enabled">{{scope.name}}</md-checkbox>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <md-button class="md-raised md-danger" @click="goRoleList">返回</md-button>
          <md-button class="md-raised md-accent" @click="removeRole">刪除角色</md-button>
        </div>
        <div class="md-layout-item">
          <md-button class="float-right md-raised md-primary" @click="submit">送出</md-button>
        </div>
      </div>
          </md-card>
  </div>
</template>

<script>
import PageTitle from '@/components/Shared/PageTitle'
import axios from 'axios'
import urls from '@/urls'

export default {
  data () {
    return {
      isEditing: null,
      roles: [],
      scopes: [],
      data: {
        scope: []
      }
    }
  },
  components: {
    PageTitle
  },
  created: async function () {
    if (this.$route.params.id !== 'add') {
      this.isEditing = this.$route.params.id
    }
    if (this.isEditing) {
      this.readRole(this.isEditing)
    }
    await this.getRole()
    await this.getScope()
  },
  watch: {
    scopes: {
      handler (newVal) {
        this.data.scope = newVal.filter(i => i.enabled)
      },
      deep: true
    }
  },
  methods: {
    goRoleList () {
      this.$router.push('/role')
    },
    getRole: async function () {
      let req = await axios.get(urls({route: 'role'}))
      this.roles = req.data.data
    },
    getScope: async function () {
      let req = await axios.get(urls({route: 'scope'}))
      let scopes = req.data.data
      this.scopes = scopes.map(i => {
        return {
          id: i.id,
          name: i.name,
          enabled: Boolean(this.data.scope.find(j => j.id === i.id))
        }
      })
    },
    submit: async function () {
      let url
      if (this.isEditing) {
        url = urls({route: 'role', id: this.isEditing})
        await axios.put(url, this.data)
      } else {
        url = urls({route: 'role'})
        await axios.post(url, this.data)
      }
      this.goRoleList()
    },
    removeRole: async function () {
      await axios.delete(urls({route: 'role', id: this.isEditing}))
      this.goRoleList()
    },
    readRole: async function (roleID) {
      let req = await axios.get(urls({route: 'role', id: this.isEditing}))
      this.data = req.data.data
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Role/RoleEdit.vue